<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <search-dsp-select v-model="tableParams.dspId" />


      <el-input v-model="tableParams.appBundle"  clearable placeholder="请输入包名"
        @input="removeBlank(tableParams.appBundle, 'appBundle')" />
      <el-input v-model="tableParams.appName"  clearable placeholder="请输入应用名"
        @input="removeBlank(tableParams.appName, 'appName')" />
      <!-- <base-date-picker @changeDate="changeDate" style="margin-right: 15px" /> -->
      <el-date-picker v-model="date" @change="changeDate" :default-time="defaultTime" type="datetimerange" unlink-panels
        style="margin-right: 15px;" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"
        :shortcuts="shortcuts" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column @search="searchColumn" @refresh="toQuery" @change="changeColumn" :column="columns"
        style="padding-bottom: 10px">
        <el-button @click="
          downExcel(
            '/webReportKeyword/total/list/csv',
            '总关键字报表',
            tableParams
          )
        " type="warning" size="small">下载</el-button>
      </table-column>

      <el-table v-loading="tableLoading" :data="tableData" height="80vh" :header-cell-style="{ background: '#fafafa' }"
        highlight-current-row size="small" class="js-table" style="width: 100%" @sort-change="sortChange">
        <el-table-column v-for="(v, i) in checkColumns" :prop="v.field" :label="v.title" :width="v.width"
          :min-width="v.minWidth" :key="i" align="center" :sortable="
            v.field === 'showSmt' ||
            v.field === 'timeKey' ||
            v.field === 'keyword' ||
            v.field === 'contactPhone' ||
            v.field === 'hit' ||
            v.field === 'hitRate' ||
            v.field === 'expensesEcpm' ||
            v.field === 'auctionPrice' ||
            v.field === 'expensesAge' ||
            v.field === 'incomeEcpm' ||
            v.field === 'incomeAge' ||
            v.field === 'winPrice' ||
            v.field === 'clkSmt'
          ">
          <template v-slot="scope">
            <el-tag v-if="
              v.field === 'showRat' ||
              v.field === 'clickRate'
            " type="info">{{ scope.row[v.field] }}%</el-tag>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="pagination.total"
        :pager-count="6" :current-page="pagination.pageNum" :page-size="pagination.pageSize" :page-sizes="[10, 30, 60]"
        background layout="total,sizes,prev,pager,next" style="margin-top: 40px" />
    </div>
  </div>
</template>

<script>
import TableColumn from '@/components/TableColumn'
import BaseDatePicker from '@/components/BaseDatePicker'
import downExcelMixin from '@/mixins/downExcel'
import initTableMixin from '@/mixins/initTable'
import SearchDspSelect from "@/components/SearchDspSelect";
import { formatDate, PURE_DATETIME_H_PATTERN } from '@/util/format'
import { webReportBiddingFailList } from '@/api/manage/keyword/biddingFail'
export default {
  name: 'Manage/keyword/biddingFail',
  components: {
    TableColumn,
    BaseDatePicker,
    SearchDspSelect
  },
  mixins: [initTableMixin, downExcelMixin],
  data() {
    return {
      defaultTime: [
        new Date(0, 0, 0, 0, 0, 0),
        new Date(0, 0, 0, 23, 0, 0),
      ],
      columns: [
        { field: 'timeHour', title: '小时' },
        // { field: 'dspType', title: '请求数' },
        { field: 'dspName', title: 'DSP名称' },
        { field: 'appBundle', title: '应用包名' },
        { field: 'appName', title: '应用名称' },
        { field: 'keyword', title: '关键字' },
        { field: 'errorCode', title: '错误码' },
        { field: 'description', title: '描述' },
        { field: 'count', title: '数量' }
        // { field: 'contactPhone', title: '下载数' },
        // { field: 'hitRate', title: '命中率' }
      ],
      shortcuts: [
        {
          text: '今天',
          value: (() => {
            const start = new Date(new Date().toLocaleDateString()).getTime()
            const end = start + 23 * 60 * 60 * 1000 + (59 * 60 * 1000)
            return [start, end]
          })()
        }, {
          text: '昨天',
          value: (() => {
            const start = new Date(new Date().toLocaleDateString()).getTime() - 3600 * 24 * 1000
            const end = start + 23 * 60 * 60 * 1000 + (59 * 60 * 1000)
            return [start, end]
          })()
        }, {
          text: '最近三天',
          value: (() => {
            const start = new Date(new Date().toLocaleDateString()).getTime() - 2 * 3600 * 24 * 1000
            const end = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000
            return [start, end]
          })()
        }, {
          text: '最近一周',
          value: (() => {
            const start = new Date(new Date().toLocaleDateString()).getTime() - 6 * 3600 * 24 * 1000
            const end = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000
            return [start, end]
          })()
        }],
      date: undefined,
    }
  },
  created() {
    this.dateInit()
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    beforeInit() {
      this.tableParams.pageNum = this.pagination.pageNum
      this.tableParams.pageSize = this.pagination.pageSize
      return false
    },
    dateInit() {
      if (this.defaultDate) {
        this.date = this.defaultDate
      } else {
        this.date = [new Date(), new Date()]
      }
      this.changeDate()
    },
    changeDate() {
      // this.tableParams.startTime = date.startTime
      // this.tableParams.endTime = date.endTime
      const date = this.date
      if (!(date[0] instanceof Date)) {
        date[0] = date[0].$d
        date[1] = date[1].$d
      }
      date[0] = formatDate(this.date[0], PURE_DATETIME_H_PATTERN)
      date[1] = formatDate(this.date[1], PURE_DATETIME_H_PATTERN)
      this.tableParams.startTime = this.date[0]
      this.tableParams.endTime = this.date[1]
    },
    sortChange(column, prop, order) {
      if (column.order === "ascending") {
        this.tableParams.asc = column.prop
        this.tableParams.desc = ""
      } else if (column.order === "descending") {
        this.tableParams.desc = column.prop
        this.tableParams.asc = ""
      }
      this.init()
    },
    toQuery() {
      if (!this.tableParams.appBundle&&!this.tableParams.appName) {
        this.$message.error('请输入应用包名或应用名');
        return
      }
      this.webReportBiddingFailList(this.tableParams)
      //   this.tableParams.pageNum = this.pagination.pageNum
      //   this.tableParams.pageSize = this.pagination.pageSize
      //   this.init()
    },
    sizeChange(e) {
      this.pagination.pageSize = e
      this.tableParams.pageSize = e
      this.init()
    },
    currentChange(e) {
      this.pagination.pageNum = e
      this.tableParams.pageNum = e
      this.init()
    },
    removeBlank(val, name) {
      this.tableParams[name] = val.replace(/^\s+|\s+$/gm, '')
    },
    webReportBiddingFailList(data) {
      webReportBiddingFailList(data).then(res => {
        this.tableData = res.data.records
      })
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  &>* {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  &>.el-select,
  &>.el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
</style>
